import type { ClientType } from '@susu/custom-made/utils/constants';
import { ConfiguratorOrigin } from '@susu/custom-made/utils/constants';
import type { ProductType } from '@susu/custom-made/utils/productDefinition';
import { isFalsy } from '@susu/custom-made/utils/utils';

export interface FeatureFlagsConfig {
  countryCode: string;
  client: ClientType;
  product: ProductType;
  reorder: string;
  sessionId: string;
  storeID: string;
  search: string;
  origin: ConfiguratorOrigin;
  isTest?: string;
}

// Must stay in lockstep with the flag rules in the feature-flag dashboard
// (tag IT-CM): these names and value transforms are what the rules target.
export const toFeatureFlagAttributes = ({
  countryCode,
  client,
  product,
  reorder,
  sessionId,
  storeID,
  search,
  origin,
  isTest,
}: FeatureFlagsConfig) => ({
  countryCode,
  client,
  product,
  reorder: !isFalsy(reorder),
  sessionId: sessionId ?? null,
  storeID,
  search: !isFalsy(search),
  isCloneFlow: origin === ConfiguratorOrigin.Clone,
  isTest: isTest === 'true',
});
